import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { type SafeHtml } from 'kerfjs';
import { Bot } from 'lucide';

export function AiDetectedLabel({ detected }: { detected: boolean }): SafeHtml {
  return detected ? (
    <span class="ai-detected-label" title="Detected by the assistant" aria-label="AI-detected">
      <LucideIcon icon={Bot} name="AI-detected" />
    </span>
  ) : (
    <></>
  );
}

/** A quotation was AI-detected when its lines came from an uploaded document
 *  (howReceived pdf/photo/comparison-sheet) rather than manual entry (HS2-44K43E). */
export function quoteFromAi(howReceived: string | null): boolean {
  return howReceived !== null && howReceived !== 'manual';
}
